interface Error {
  height?: string;
  width?: string;
  className?: string;
  alt?: string;
}

export const ErrorIcon = ({ height = "20", width = "21", className, alt }: Error) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>{alt}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 2C8.37827 2 6.34344 2.84285 4.84315 4.34315C3.34285 5.84344 2.5 7.87827 2.5 10C2.5 11.0506 2.70693 12.0909 3.10896 13.0615C3.511 14.0321 4.10028 14.914 4.84315 15.6569C5.58601 16.3997 6.46793 16.989 7.43853 17.391C8.40914 17.7931 9.44942 18 10.5 18C11.5506 18 12.5909 17.7931 13.5615 17.391C14.5321 16.989 15.414 16.3997 16.1569 15.6569C16.8997 14.914 17.489 14.0321 17.891 13.0615C18.2931 12.0909 18.5 11.0506 18.5 10C18.5 7.87827 17.6571 5.84344 16.1569 4.34315C14.6566 2.84285 12.6217 2 10.5 2ZM3.42893 2.92893C5.3043 1.05357 7.84784 0 10.5 0C13.1522 0 15.6957 1.05357 17.5711 2.92893C19.4464 4.8043 20.5 7.34784 20.5 10C20.5 11.3132 20.2413 12.6136 19.7388 13.8268C19.2362 15.0401 18.4997 16.1425 17.5711 17.0711C16.6425 17.9997 15.5401 18.7362 14.3268 19.2388C13.1136 19.7413 11.8132 20 10.5 20C9.18678 20 7.88642 19.7413 6.67317 19.2388C5.45991 18.7362 4.35752 17.9997 3.42893 17.0711C2.50035 16.1425 1.76375 15.0401 1.2612 13.8268C0.758658 12.6136 0.5 11.3132 0.5 10C0.5 7.34784 1.55357 4.8043 3.42893 2.92893ZM10.5 5C11.0523 5 11.5 5.44772 11.5 6V10C11.5 10.5523 11.0523 11 10.5 11C9.94771 11 9.5 10.5523 9.5 10V6C9.5 5.44772 9.94771 5 10.5 5ZM9.5 14C9.5 13.4477 9.94771 13 10.5 13H10.51C11.0623 13 11.51 13.4477 11.51 14C11.51 14.5523 11.0623 15 10.51 15H10.5C9.94771 15 9.5 14.5523 9.5 14Z"
      fill="#B34247"
    />
  </svg>
);
